/**
 * China Chat component
 */
(function () {
    'use strict';

    var itxKakaoChatCmp = {
        controller: itxKakaoChatCmpCtrl,
        templateUrl: 'kakao-chat.component.html',
        bindings: {
            config: '<'
        }
    };

    itxKakaoChatCmpCtrl.$inject = ['ItxKakaoSvc'];

    function itxKakaoChatCmpCtrl( ItxKakaoSvc ) {
        var _this = this;

        /**
         * Función para cerrar el chat
         */
        _this.close = function () {
            ItxKakaoSvc.close();
        };
    }

    angular.module('itxApp.common').component('itxKakaoChat', itxKakaoChatCmp);
})();
